(() => {
  const initialized = new WeakSet();

  function rootPath() {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  }

  function unique(items) {
    return [...new Set(items.filter(Boolean))];
  }

  function navigate(handle) {
    if (!handle) return;
    window.location.assign(`${rootPath()}products/${encodeURIComponent(handle)}`);
  }

  function optionButton(entry, kind, current) {
    const label = kind === 'color' ? entry.c : entry.s;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `sm-linked-product-picker__option sm-linked-product-picker__option--${kind}`;
    if (!entry.a) button.classList.add('sm-linked-product-picker__option--sold-out');
    button.setAttribute('aria-current', entry.h === current.h ? 'true' : 'false');
    button.setAttribute('aria-label', `${label}${entry.a ? '' : ' — Sold out'}`);
    button.title = `${label}${entry.a ? '' : ' — Sold out'}`;

    if (kind === 'color' && entry.i) {
      const image = document.createElement('img');
      image.className = 'sm-linked-product-picker__thumb';
      image.src = entry.i;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 96;
      image.height = 96;
      button.append(image);
    } else {
      const text = document.createElement('span');
      if (kind === 'color') text.className = 'sm-linked-product-picker__text-swatch';
      text.textContent = label;
      button.append(text);
    }
    button.addEventListener('click', () => navigate(entry.h));
    return button;
  }

  function renderGroup(root, label, value, entries, kind, current) {
    const group = document.createElement('div');
    group.className = 'sm-linked-product-picker__group';
    const legend = document.createElement('p');
    legend.className = 'sm-linked-product-picker__legend';
    legend.append(`${label}: `);
    const selected = document.createElement('span');
    selected.className = 'sm-linked-product-picker__value';
    selected.textContent = value;
    legend.append(selected);
    const options = document.createElement('div');
    options.className = `sm-linked-product-picker__options sm-linked-product-picker__options--${kind}s`;
    entries.forEach((entry) => options.append(optionButton(entry, kind, current)));
    group.append(legend, options);
    root.append(group);
  }

  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const data = window.StoreForgeSimpleModernLinkedProducts;
    const handle = root.dataset.currentHandle;
    const groupIndex = data?.byHandle?.[handle];
    const items = Number.isInteger(groupIndex) ? data.groups?.[groupIndex]?.items : null;
    if (!Array.isArray(items) || items.length < 2) return;
    const current = items.find((entry) => entry.h === handle);
    if (!current) return;

    const sizes = unique(items.map((entry) => entry.s));
    const colors = unique(items.map((entry) => entry.c));
    if (sizes.length > 1) {
      const sizeEntries = sizes.map((size) =>
        items.find((entry) => entry.s === size && entry.c === current.c)
        || items.find((entry) => entry.s === size)
      );
      renderGroup(root, 'Size', current.s || sizes[0], sizeEntries, 'size', current);
    }
    if (colors.length > 1) {
      const matchingSize = current.s ? items.filter((entry) => entry.s === current.s) : items;
      const colorEntries = unique(matchingSize.map((entry) => entry.c)).map((color) =>
        matchingSize.find((entry) => entry.c === color)
      );
      renderGroup(root, 'Color', current.c || colors[0], colorEntries, 'color', current);
    }
    if (root.childElementCount) root.hidden = false;
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-sm-linked-product-picker]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
